import Diamond from "@icons/diamond.svg?react";
import Ellipse from "@icons/ellipse.svg?react";

const PremiumBadge = ({ children }: React.PropsWithChildren) => {
  return (
    <>
      <span
        className="absolute left-4 top-2 grid place-content-center place-items-center [&_path]:fill-[#ffffff]"
        data-testid="badge"
      >
        <Ellipse className="h-4 w-4" style={{ gridColumn: 1, gridRow: 1 }} />
        <Diamond style={{ gridColumn: 1, gridRow: 1 }} />
      </span>
      {children}
    </>
  );
};

export { PremiumBadge };
